var _circle, _path, _polygon, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8FootWash50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11,30c0-5,1-4,1-8c0-3,0-11,0-11h14v9c0,2.761,2.239,5,5,5l0,0c3.866,0,7,3.134,7,7l0,0H25l-6-2H11z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "18.838,32 11,32 11,36 19,36 19,34.054 24.838,36 25,36 38,36 38,34 24.838,34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32,13.5c0,0.828-0.672,1.5-1.5,1.5S29,14.328,29,13.5c0-1,1.5-2.5,1.5-2.5S32,12.5,32,13.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38,19.5c0,1.381-1.119,2.5-2.5,2.5S33,20.881,33,19.5c0-1.667,2.5-4.5,2.5-4.5S38,17.833,38,19.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FootWash50);
export default __webpack_public_path__ + "static/media/icons8-foot-wash-50.03ce87119d010c3cce6f929e5cda9d4e.svg";
export { ForwardRef as ReactComponent };